import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { PathPart } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderTextInputFieldFormFieldTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx-nested/render-text-input-field.js'
import { pathNameProp } from './path-name-prop.js'

export function renderTextInputField(
  field: SchemaField,
  indent: string,
  label: string,
  nestedHint: string,
  path: PathPart[]
): string {
  return renderTextInputFieldFormFieldTemplate({
    indent: indent,
    pathNameProp: pathNameProp(path),
    formItemProps: formItemProps(field),
    labelWithDescription: labelWithDescription(
      formLabel(field, label),
      nestedHint,
      `${indent}      `
    ),
    toLowerCase: label.toLowerCase()
  })
}
